import React, { useEffect } from "react";

// Redux Selector / Action
import { useDispatch } from 'react-redux';

// Firebase Provider - REMOVED
// import { FirebaseProvider } from '../contexts/FirebaseContext';
import { setSetting } from '../store/setting/actions';

interface LayoutProps {
    children: React.ReactNode;
}

const AppLayout = ({ children }: LayoutProps) => {
    const dispatch = useDispatch()

    useEffect(() => {
        // Initialize settings when the app loads
        dispatch(setSetting({}))
    }, [dispatch])

    // Remove FirebaseProvider wrapper
    return (
        <>
            {children}
        </>
    );
};
export default AppLayout;
